<template>
  <div class="card">
    <div class="card-body bg-info text-center p-15 head">
      <p class="head">
        <strong>Our Last Week Usage Report</strong>
        <Btn
          class="btn waves-effect text-left btn-success btn-sm btn-success"
          @click="get()"
          :process="data == null"
        >
          <span>Yenile</span>
        </Btn>
      </p>
    </div>
    <div class="card-body p-0">
      <load-area v-if="data == null"></load-area>
      <div class="row" v-if="data != null">
        <div class="col-xl-9 col-lg-8 col-md-7 col-12 p-r-0">
          <apexChart
            :data="getDatasets()"
            :height="237"
            :chartOptions="chartOptions"
          ></apexChart>
        </div>
        <div class="col-xl-3 col-lg-4 col-md-5 col-12 border-left right">
          <div class="row">
            <div class="col-12">
              <div class="card">
                <div class="card-body p-10">
                  <div class="d-flex flex-row">
                    <div class="round round-md align-self-center round-info">
                      <i class="ti-plus"></i>
                    </div>
                    <div class="m-l-10 align-self-center">
                      <h3 class="m-b-0 font-lgiht">
                        <Vue3Autocounter
                          ref="counter"
                          :startAmount="0"
                          :endAmount="getSum('Added')"
                          :duration="1"
                        />
                      </h3>
                      <h6 class="text-muted m-b-0">
                        Added
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card">
                <div class="card-body p-10">
                  <div class="d-flex flex-row">
                    <div class="round round-md align-self-center round-success">
                      <i class="ti-settings"></i>
                    </div>
                    <div class="m-l-10 align-self-center">
                      <h3 class="m-b-0 font-lgiht">
                        <Vue3Autocounter
                          ref="counter"
                          :startAmount="0"
                          :endAmount="getSum('Operated')"
                          :duration="1"
                        />
                        <small style="font-size:70%"
                          >(%<Vue3Autocounter
                            ref="counter"
                            :startAmount="0"
                            :endAmount="
                              getSum('Percentage') / data.Summary.length
                            "
                            :duration="1"
                          />)</small
                        >
                      </h3>
                      <h6 class="text-muted m-b-0">
                        Operated
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <a
                href="#/report/using"
                class="btn waves-effect text-left btn-success btn-md btn-success btn-md w100 tcenter"
                ><span>Detaylı İncele</span></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue3Autocounter from "vue3-autocounter";
import apexChart from "./../../components/apexChart.vue";
export default {
  name: "usingReport",
  components: { Vue3Autocounter, apexChart },
  data() {
    return {
      tab: "usingReport",
      data: null,
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            borderRadius: 5,
            borderRadiusApplication: "last",
          },
        },
        xaxis: {
          categories: [2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016],
        },
        tooltip: {
          y: {
            formatter: function(val, pro) {
              console.log("x", val, pro);
              if (val == 0) {
                return "";
              }
              return val;
            },
          },
        },
        dataLabels: {
          formatter: function(val) {
            return (val / 1000).toFixed(1);
          },
        },
      },
    };
  },
  created() {
    this.get();
  },
  methods: {
    get() {
      this.data = null;
      var startDate = new Date();
      startDate.setDate(startDate.getDate() - 6);
      this.$appAxiosAdmin
        .post(`KOLAYREZ/Reports/UsingReport`, {
          StartDate: this.$moment(new Date(startDate)).format("YYYY-MM-DD"),
          EndDate: this.$moment(new Date()).format("YYYY-MM-DD"),
        })
        .then((response) => {
          this.data = response.data;
          console.log(this.data);
        });
    },
    getDatasets(datas = this.data.Summary) {
      var operated = [];
      var agencyConfirmed = [];
      var agencyNotConfirmed = [];
      var added = [];
      let xAxis = [];
      datas.forEach((element) => {
        xAxis.push(this.$moment(new Date(element.Date)).format("DD.MM.YY"));
        operated.push(element.Operated);
        agencyConfirmed.push(element.AgencyConfirmed);
        agencyNotConfirmed.push(element.AgencyNotConfirmed);
        added.push(element.Added);
      });
      this.chartOptions.xaxis.categories = xAxis;
      return [
        {
          name: "Added",
          type: "column",
          data: added,
        },
        {
          name: "Operated",
          type: "column",
          fillColor: "#FF0000",
          data: operated,
        },
        {
          name: "Agency Confirmed",
          type: "column",
          fillColor: "#ffb22b",
          data: agencyConfirmed,
        },
        {
          name: "Agency Not Confirmed",
          type: "column",
          fillColor: "#fc4b6c",
          data: agencyNotConfirmed,
        },
      ];
    },
    getSum(type) {
      let sum = 0;
      this.data.Summary.forEach((element) => {
        sum += element[type];
      });
      return sum;
    },
  },
};
</script>
<style scoped>
.head {
  position: relative;
}
.head .btn {
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -17px;
}
.card-body {
  overflow: hidden;
}
.head strong {
  color: #fff;
  font-weight: 500;
}
.right {
  padding: 16px 31px 16px 16px;
}
.right > .row {
  margin: -8px;
}
.right > .row > div {
  padding: 8px;
}
.right > .row > div .card {
  margin-bottom: 0;
}
.round-success {
  background: #55ce63;
}
.bg-success {
  background: #55ce63 !important;
}
@media (max-width: 991px) {
  .left {
    padding-right: 15px;
    border-right: none !important;
  }
  .right > .row {
    margin: -4px;
  }
  .right > .row > div {
    padding: 4px;
  }
  .right > .row > div .round {
    width: 36px;
    height: 36px;
  }
  .right > .row > div .round i {
    display: block;
    line-height: 36px;
  }
  .right > .row > div h4 {
    font-size: 16px;
  }
  .right > .row > div h6 {
    font-size: 12px;
  }
}
@media (max-width: 767px) {
  .left,
  /deep/ .left {
    padding-right: 15px !important;
  }
  .right {
    padding: 16px 31px;
    border-top: 1px solid #dee2e6 !important;
  }
}
</style>
